module.exports = __webpack_public_path__ + "static/dosage_safety_chart-24152fe0c1bf3f28ab2eaa7b28c93b99.pdf";